module.exports = __webpack_public_path__ + "static/media/blom-pysanky-thumb-18.8007380d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-thumb-18.jpg
// module id = 3972
// module chunks = 14